import React from 'react';

import { useResponsive } from '@sg/garnish';

import { ConfirmLocationLayoutSM } from './ConfirmLocationLayoutSM';
import { ConfirmLocationLayoutXS } from './ConfirmLocationLayoutXS';

import type { ConfirmLocationLayoutProps } from './ConfirmLocationLayout.types';

export const ConfirmLocationLayout = (props: ConfirmLocationLayoutProps) => {
  const { match } = useResponsive();
  const ConfirmLocationLayoutComponent = match([ConfirmLocationLayoutXS, ConfirmLocationLayoutSM]);

  return <ConfirmLocationLayoutComponent {...props} />;
};
